<template>
  <div>
    <send-message-x @onViewRecord="handleViewRecord" :uploadAgainDB="uploadAgainDB" :sendType="sendType"></send-message-x>
  </div>
</template>

<script>
import sendMessageX from "@/components/send-message-x.vue";
export default {
  name: 'designatedSend',
  components: {
    sendMessageX
  },
  data() {
    return {
      sendType: 4
    }
  },
  props: {
    uploadAgainDB: {
      type: Object,
      default: () => {}
      // 指定号码发送上传手机号码, 变量短信发送
      // totalMobile fid content
    },
  },
  methods: {
    handleViewRecord() {
      this.$emit('onViewRecord')
    },
  }
}
</script>

<style lang="scss" scoped>

</style>